import { createSlice } from "@reduxjs/toolkit";

export interface addressStateType {
  loading: boolean;
  successMessage: {};
  error: Error | null;
}
const initialState: addressStateType = {
  loading: false,
  successMessage: {},
  error: null,
};

export const addressStateSlice = createSlice({
  name: "addressStateSlice",
  initialState,
  reducers: {
    // Delete address
    deleteAddressById: (state, action) => {
      state.loading = true;
    },
    deleteAddressSuccess: (state, action) => {
      state.loading = false;
    },
    deleteAddressError: (state, action) => {
      state.loading = false;
    },

    // Add address
    addAddress: (state, action) => {
      state.loading = true;
      // console.log("In add Address");
    },
    addAddressSuccess: (state, action) => {
      state.loading = false;
    },
    addAddressError: (state, action) => {
      state.loading = false;
    },

    // UPDATE address
    updateAddress: (state, action) => {
      // console.log("in update address");
      state.loading = true;
    },
    updateAddressSuccess: (state, action) => {
      state.loading = false;
    },
    updateAddressError: (state, action) => {
      state.loading = false;
    },
  },
});

export const {
  deleteAddressById,
  deleteAddressSuccess,
  deleteAddressError,
  addAddress,
  addAddressSuccess,
  addAddressError,
  updateAddress,
  updateAddressSuccess,
  updateAddressError,
} = addressStateSlice.actions;

export default addressStateSlice.reducer;
